module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-2-5bf82e5602a608de865dd7d88dd9a079.png";